import React, { useState, useEffect, useContext } from "react";
import axios from "axios";

import Button from "@mui/material/Button";
import { makeStyles, withStyles } from "@mui/styles";
import Slider from "@mui/material/Slider";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import {
  AutocompleteInput,
  CustomSelect,
  CustomSwitch,
  DateInput,
  FloatInput,
  IntInput,
  LocalizationAutocomplete,
  TextInput,
} from "components/Input/Index.js";
import { compte } from "variables/patrimoine.js";
import { ActionContext } from "context/ActionContext";
import {
  calculateTurpeEco,
  optimizePsous,
} from "utilities/fonctionsturpe.js";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import { action as actionVar } from "variables/action";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      backgroundColor: '#fff',
      //width: "30ch",
    },
  },
  formControl: {
    margin: '8px',
    minWidth: 120,
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0rem 0rem",
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
  },
  select: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0.5rem",
  },
  switch: {
    marginLeft: "0.5rem",
  },
}));

const GreenSwitch = withStyles((theme) => ({
  root: {
    width: 42,
    height: 26,
    padding: 0,
    margin: '8px',
  },
  switchBase: {
    padding: 1,
    "&$checked": {
      transform: "translateX(16px)",
      color: '#fff',
      "& + $track": {
        backgroundColor: "#91C73C",
        opacity: 1,
        border: "none",
      },
    },
    "&$focusVisible $thumb": {
      color: "#91C73C",
      border: "6px solid #fff",
    },
  },
  thumb: {
    width: 24,
    height: 24,
  },
  track: {
    borderRadius: 26 / 2,
    border: `1px solid ${'#bdbdbd'}`,
    backgroundColor: theme.palette.grey[50],
    opacity: 1,
    transition: theme.transitions.create(["background-color", "border"]),
  },
  checked: {},
  focusVisible: {},
}))(({ classes, ...props }) => {
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
      {...props}
    />
  );
});

function valuetext(value) {
  return `${value}%`;
}

const PrettoSlider = withStyles({
  root: {
    color: "#91C73C",
    height: 8,
  },
  thumb: {
    height: 24,
    width: 24,
    backgroundColor: "#fff",
    border: "2px solid currentColor",
    marginTop: -8,
    marginLeft: -12,
    "&:focus, &:hover, &$active": {
      boxShadow: "inherit",
    },
  },
  active: {},
  valueLabel: {
    left: "calc(-50% + 4px)",
  },
  track: {
    height: 8,
    borderRadius: 4,
  },
  rail: {
    height: 8,
    borderRadius: 4,
  },
})(Slider);
const marks = [
  {
    value: 0,
    label: "0%",
  },
  {
    value: 100,
    label: "100%",
  },
];

function EditMeterDialog(props) {
  const actionContext = useContext(ActionContext);
  const { action, setAction } = actionContext;
  const { energy, parameters, closeModal, refetch, selectedMeter } = props;

  const { uuid: idSelected, meternumber, details } = selectedMeter;

  const [editedRow, setEditedRow] = useState(details);

  const handleSubmit = async (event) => {
    let meters = action.parameters?.impact?.meters;
    let indexOfTheMeter = meters.findIndex((c) => c.uuid === idSelected);

    let editedMeter = editedRow;

    calculateTurpeEco(editedMeter, editedRow?.recFTAEnabled, true);
    meters[indexOfTheMeter].details = editedMeter;

    setAction((prevState) => ({
      ...prevState,
      parameters: {
        ...prevState.parameters,
        impact: {
          ...prevState.parameters?.impact,
          meters,
        },
      },
    }));

    closeModal();
    //refetch();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditedRow((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSwitchChange = () => {
    setEditedRow((prevState) => ({
      ...prevState,
      recFTAEnabled: !editedRow?.recFTAEnabled,
    }));
  };



  const handleSliderChange = (event, value) => {
    let margin = Number((value * 0.01 + 1).toFixed(2));
    setEditedRow((prevState) => ({
      ...prevState,
      margin,
    }));
  };

  useEffect(() => {
    optimizePsous(editedRow);
    setEditedRow((prevState) => ({
      ...prevState,
      recps :editedRow.recps,
      recpspte :editedRow.recpspte,
      recpshph :editedRow.recpshph,
      recpshch :editedRow.recpshch,
      recpshpe :editedRow.recpshpe,
      recpshce :editedRow.recpshce,
    }));
  }, [editedRow?.margin]);

  const classes = useStyles();

  return (
    <>
      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} lg={12}>

            {editedRow?.segment?.toLowerCase() != "c5" &&
              <>
                <div
                  style={{
                    fontSize: "13px",
                    opacity: "0.85",
                    fontFamily: "Source Sans Pro,sans-serif",
                  }}
                >
                Changement de FTA
                </div>
                <div className={classes.switch}>
                  <FormControlLabel
                    control={
                      <GreenSwitch
                        checked={editedRow?.recFTAEnabled}
                        onChange={handleSwitchChange}
                      />
                    }
                  />
                </div>
              </>
            }
            <div
              style={{
                fontSize: "13px",
                opacity: "0.85",
                fontFamily: "Source Sans Pro,sans-serif",
              }}
            >
              Marge de sécurité
            </div>
            <PrettoSlider
              defaultValue={((editedRow?.margin - 1) * 100).toFixed(2)}
              getAriaValueText={valuetext}
              aria-labelledby="discrete-slider-small-steps"
              step={5}
              min={0}
              max={100}
              valueLabelDisplay="auto"
              marks={marks}
              onChangeCommitted={handleSliderChange}
            />

            {(editedRow?.segment?.toLowerCase() == "c3" || editedRow?.segment?.toLowerCase() == "c2") &&
              <IntInput
                inputTitle={actionVar.impactTURPE.pspte}
                intInput={editedRow?.recpspte}
                handleIntInputChange={handleChange}
                name="recpspte"
              />
            }
            {editedRow?.segment?.toLowerCase() != "c5" &&
              <>
                <IntInput
                  inputTitle={actionVar.impactTURPE.pshph}
                  intInput={editedRow?.recpshph}
                  handleIntInputChange={handleChange}
                  name="recpshph"
                />
                <IntInput
                  inputTitle={actionVar.impactTURPE.pshch}
                  intInput={editedRow?.recpshch}
                  handleIntInputChange={handleChange}
                  name="recpshch"
                />
                <IntInput
                  inputTitle={actionVar.impactTURPE.pshpe}
                  intInput={editedRow?.recpshpe}
                  handleIntInputChange={handleChange}
                  name="recpshpe"
                />
                <IntInput
                  inputTitle={actionVar.impactTURPE.pshce}
                  intInput={editedRow?.recpshce}
                  handleIntInputChange={handleChange}
                  name="recpshce"
                />
              </>
            }
            {editedRow?.segment?.toLowerCase() == "c5" &&
              <IntInput
                inputTitle={actionVar.impactTURPE.psmax}
                intInput={editedRow?.recps}
                handleIntInputChange={handleChange}
                name="recps"
                max={36}
              />}

          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <Button
              noWrap
              style={{
                color: "#FFFFFF",
                backgroundColor: "#91C73C",
                fontWeight: "bold",
                height: "40px",
                fontSize: "0.75rem",
                padding: "5px 15px",
                marginRight: "0px",
                marginBottom: "0px",
                marginTop: "15px",
                fontFamily: '"Source Sans Pro",sans-serif',
                width: "96%",
                marginLeft: "2%",
              }}
              onClick={() => {
                handleSubmit();
              }}
            >
              Enregistrer
            </Button>
          </GridItem>
        </GridContainer>
      </form>
    </>
  );
}

export default EditMeterDialog;
